import { render } from "./EmailRepliesDashboard.vue?vue&type=template&id=ebf887e8&scoped=true"
import script from "./EmailRepliesDashboard.vue?vue&type=script&lang=js"
export * from "./EmailRepliesDashboard.vue?vue&type=script&lang=js"

import "./EmailRepliesDashboard.vue?vue&type=style&index=0&id=ebf887e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf887e8"]])

export default __exports__